module.exports = "<p>\n  restaurants works!\n</p>\n"